import classNames from 'classnames'
import { useTranslation } from 'next-i18next'

import { TEST_LOCATORS } from '@src/constants/test-locators'
import AuthUtil from '@src/quince-site-common/src/utils/authUtil'

import { ProductCTAConstants } from './constants'
import { ProductDisplayButton } from './product-display-button'
import { ProductDisplayText } from './product-display-text'
import { RenderErrorMessage } from './productCTA'
import styles from './productCTA.module.scss'
import { ProductWaitlistCTAType } from './types'

export const ProductWaitlistCTA = (props: ProductWaitlistCTAType) => {
  const { t } = useTranslation('common')
  const {
    selectedVariantPurchaseInfo,
    isCurrentProductOptionLeavingSoon,
    isPostOrderFlow,
    isQuickATCForMobile,
    isKeyboardVisibleForQuickATCForMobile,
    trackIsVisibleWaitlistRef,
    setEmail,
    setIsKeyboardVisibleForQuickATCForMobile,
    handleClick,
    errorMessage,
    showNewPdpDesignV2,
  } = props
  const getClassNameForQuickATCWrapper = () => {
    return classNames(styles.quickATCWrapper, {
      [styles.quickATCWrapper_newDesignV2 ?? '']: showNewPdpDesignV2,
    })
  }
  if (isPostOrderFlow) {
    return (
      <ProductDisplayButton onClick={() => undefined} disabled={true} className="width--full pointer-events-none">
        {t(ProductCTAConstants.OUT_OF_STOCK)}
      </ProductDisplayButton>
    )
  }

  return isCurrentProductOptionLeavingSoon ? (
    <div className={styles.buttonWrapper}>
      <div
        className={classNames(
          styles.leavingSoon__outOfStock,
          styles.leavingSoon__outOfStock_adjustedPadding,
          showNewPdpDesignV2 && styles.leavingSoon__outOfStock_newDesignV2,
        )}
      >
        {t(ProductCTAConstants.ITEM_NO_LONGER_AVAILABLE)}
      </div>
      <ProductDisplayButton onClick={handleClick} className={styles.waitlisted} showNewPdpDesignV2={showNewPdpDesignV2}>
        {t(ProductCTAConstants.SHOP_SIMILAR)}
      </ProductDisplayButton>
    </div>
  ) : (
    <div
      data-testid={TEST_LOCATORS.PRODUCT_CTA}
      ref={trackIsVisibleWaitlistRef}
      className={classNames(styles.buttonWrapper, showNewPdpDesignV2 && styles.buttonWrapper_newDesignV2)}
    >
      <ProductDisplayText
        date={selectedVariantPurchaseInfo?.backInStockDate}
        className={classNames(styles.waitListed__text, showNewPdpDesignV2 ? styles.oosText_newDesignV2 : '')}
        isQuickATCForMobile={isQuickATCForMobile}
        showNewPdpDesignV2={showNewPdpDesignV2}
      />
      {!selectedVariantPurchaseInfo?.hasJoinedWaitList && !AuthUtil.isLoggedIn() && (
        <input
          onChange={e => setEmail?.(e.target.value)}
          onFocus={() => setIsKeyboardVisibleForQuickATCForMobile?.(true)}
          onBlur={() => setIsKeyboardVisibleForQuickATCForMobile?.(false)}
          className={classNames(
            styles.waitlistInput,
            isQuickATCForMobile && styles.waitlistInput__quickATC,
            styles.waitlistInput_adjustedPadding,
            showNewPdpDesignV2 && styles.waitlistInput_newDesignV2,
          )}
          placeholder={
            isQuickATCForMobile || showNewPdpDesignV2 ? t('enter_your_email_address') : t('your_email_address')
          }
          type="email"
        />
      )}
      {errorMessage && (
        <RenderErrorMessage
          className={showNewPdpDesignV2 ? styles.errorMessage_newDesignV2 : ''}
          errorMessage={errorMessage}
          isQuickATCForMobile={isQuickATCForMobile}
          showNewPdpDesignV2={showNewPdpDesignV2}
        />
      )}

      {isQuickATCForMobile ? (
        !isKeyboardVisibleForQuickATCForMobile && (
          <div className={getClassNameForQuickATCWrapper()}>
            {selectedVariantPurchaseInfo?.hasJoinedWaitList ? (
              <ProductDisplayButton onClick={handleClick} className={styles.waitlisted}>
                {t(ProductCTAConstants.WAITLISTED)}
              </ProductDisplayButton>
            ) : (
              <ProductDisplayButton onClick={handleClick}>{t(ProductCTAConstants.JOIN_WAITLIST)}</ProductDisplayButton>
            )}
          </div>
        )
      ) : selectedVariantPurchaseInfo?.hasJoinedWaitList ? (
        <ProductDisplayButton
          showNewPdpDesignV2={showNewPdpDesignV2}
          onClick={handleClick}
          className={classNames(styles.waitlisted, showNewPdpDesignV2 && styles.waitlisted_newDesignV2)}
        >
          {t(ProductCTAConstants.WAITLISTED)}
        </ProductDisplayButton>
      ) : (
        <ProductDisplayButton
          className={showNewPdpDesignV2 ? styles.waitlisted_newDesignV2 : ''}
          showNewPdpDesignV2={showNewPdpDesignV2}
          onClick={handleClick}
        >
          {t(ProductCTAConstants.JOIN_WAITLIST)}
        </ProductDisplayButton>
      )}
    </div>
  )
}
